import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHeader } from '../../components/layout/PageHeader';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { School, BookOpen, GraduationCap, UserPlus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../utils/constants';

export const AdminDashboard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <PageHeader
        title="School Admin Dashboard"
        subtitle="Manage your school, classes, students, and invites"
      />
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <Card hover onClick={() => navigate(ROUTES.ADMIN_SCHOOL)} className="cursor-pointer">
          <CardHeader>
            <div className="flex items-center gap-3">
              <div className="p-3 bg-primary-100 dark:bg-primary-900 rounded-lg">
                <School className="w-6 h-6 text-primary-600 dark:text-primary-400" />
              </div>
              <CardTitle>School Profile</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              View and update school information
            </p>
          </CardContent>
        </Card>

        <Card hover onClick={() => navigate(ROUTES.ADMIN_CLASSES)} className="cursor-pointer">
          <CardHeader>
            <div className="flex items-center gap-3">
              <div className="p-3 bg-secondary-100 dark:bg-secondary-900 rounded-lg">
                <BookOpen className="w-6 h-6 text-secondary-600 dark:text-secondary-400" />
              </div>
              <CardTitle>Classes</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Manage classes and sections
            </p>
          </CardContent>
        </Card>

        <Card hover onClick={() => navigate(ROUTES.ADMIN_STUDENTS)} className="cursor-pointer">
          <CardHeader>
            <div className="flex items-center gap-3">
              <div className="p-3 bg-success-100 dark:bg-success-900 rounded-lg">
                <GraduationCap className="w-6 h-6 text-success-600 dark:text-success-400" />
              </div>
              <CardTitle>Students</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              View and manage students
            </p>
          </CardContent>
        </Card>

        <Card hover onClick={() => navigate(ROUTES.ADMIN_INVITE_TEACHER)} className="cursor-pointer">
          <CardHeader>
            <div className="flex items-center gap-3">
              <div className="p-3 bg-accent-100 dark:bg-accent-900 rounded-lg">
                <UserPlus className="w-6 h-6 text-accent-600 dark:text-accent-400" />
              </div>
              <CardTitle>Invites</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Invite teachers, parents, and students
            </p>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

